import ApplicationAccordion from './ApplicationAccordion';
import { ApplicationAccordionFieldProps } from './index';

const View = ({ content }: { content: ApplicationAccordionFieldProps }) => {
  return <ApplicationAccordion content={content} />;
};

export default View;
